import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLineChart1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"line-chart-1, statistics, graph"} maskId="square-filled-radius-0-stroke-1-IconLineChart1"><path d="M4 20V3H3V21H22V20H4Z" fill="currentColor"/><path d="M15 17V4H14V17H15Z" fill="currentColor"/><path d="M10 17V10H9V17H10Z" fill="currentColor"/><path d="M20 17V12H19V17H20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLineChart1;
